/* BILLINGS */
export const GET_BILLINGS = "GET_BILLINGS"
export const GET_BILLINGS_SUCCESS = "GET_BILLINGS_SUCCESS"
export const GET_BILLINGS_FAIL = "GET_BILLINGS_FAIL"